const FETCH_VENDORS = 'fetch_vendors';
const FETCH_VENDORS_SIMPLY = 'fetch_vendors_simply';
const FETCH_VENDOR = 'fetch_vendor';
const DELETE_VENDOR = 'delete_vendor';
const PERSIST_VENDOR = 'persist_vendor';
const CREATE_FILES_VENDOR = 'create_files_vendor';
const DELETE_FILE_VENDOR = 'delete_file_vendor';
const FETCH_FILES_VENDOR = 'fetch_files_vendor';
export default {
    FETCH_VENDORS,
    FETCH_VENDORS_SIMPLY,
    FETCH_VENDOR,
    DELETE_VENDOR,
    PERSIST_VENDOR,
    FETCH_FILES_VENDOR,
    DELETE_FILE_VENDOR,
    CREATE_FILES_VENDOR,
};
